import React, {Component} from 'react'
import PropTypes from "prop-types";
import Error from "../single_components/Error";
import Select from "react-select";
import {authenticationService} from "../../services/AuthenticationService";

class LeumitDoctorsReferral extends Component {

    constructor(props) {
        super(props);
        this.state = {
            entry: this.props.entry,
        }
    }

    componentDidMount() {
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.entry !== prevProps.entry) {
            this.setState({
                entry: this.props.entry
            })
        }
    }

    render() {
        let {t} = this.props

        let {entry} = this.state

        return (
            <div className={'patientsFormBoxes-referral'}>
                <div className={'patientsFormRow'}>
                    <div className={'inputSlotsFlex'}>
                        <div className={'infoLabel-error-block'}>

                            <label
                                className={'infoLabel-withError'}>{t('patient_boarding.Recommendation_letter_use_cannabis')}?</label>
                            <Error isShown={!!(this.props.errors)['Recommendation_letter_use_cannabis']}
                                   errorMessage={(this.props.errors)['Recommendation_letter_use_cannabis']}/>
                        </div>
                        <div className={'inputBoxStyle-yes-no-block'}>

                            <button tabIndex={0}
                                    className={entry.Recommendation_letter_use_cannabis === "Yes" ? 'inputBoxStyle-yes-no-left-selected' : 'inputBoxStyle-yes-no-left'}
                                    onClick={(event) => this.props.onYesNoValueChange("Recommendation_letter_use_cannabis", "Yes")}>{t('patient_boarding.yes')}</button>

                            <button tabIndex={0}
                                    className={entry.Recommendation_letter_use_cannabis === "No" ? 'inputBoxStyle-yes-no-right-selected' : 'inputBoxStyle-yes-no-right'}
                                    onClick={(event) => this.props.onYesNoValueChange("Recommendation_letter_use_cannabis", "No")}>{t('patient_boarding.no')}</button>
                        </div>
                    </div>
                </div>


                {entry.Recommendation_letter_use_cannabis === "Yes" &&
                <div className={'inputSlotsDoc-full'}>
                    <label/>
                    <textarea className={'info-inputBoxStyle boxMargin'} defaultValue={entry.doctors_referral}
                              maxLength={"5000"}
                              onChange={(event) => this.props.onValueChange("doctors_referral", event.target.value)}/>

                </div>}

            </div>

        )
    }
}

LeumitDoctorsReferral.propTypes = {
    onValueChange: PropTypes.func.isRequired,
    entry: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool
}

export default LeumitDoctorsReferral;
